export const STATUS_AVAILABLE = 'available';
export const STATUS_PENDING_PAYMENT = 'pending_payment';
export const STATUS_DEPOSIT_CREATED = 'created_deposit';
export const STATUS_DEPOSIT_PAID = 'deposit_paid';
